/* eslint-disable max-len */
export const pricingAreaMockedData = {
  "productId": 79,
  "title": "Sleek Plastic Watch",
  "price": "$22.12",
  "free": false,
  "license": "royalty_free_no_ai",
  "customLicense": "<p><span class=\"translation_missing\" title=\"translation missing: en.licenses_new.summary.royalty_free_no_ai_html, link: &lt;form rel=&quot;nofollow&quot; class=&quot;license-form&quot; method=&quot;get&quot; action=&quot;/items/79/license&quot; data-remote=&quot;true&quot;&gt;&lt;input class=&quot;js-auto-disable-link js-license license button button--transparent&quot; rel=&quot;nofollow&quot; type=&quot;submit&quot; value=&quot;Royalty Free No Ai License&quot; /&gt;&lt;/form&gt;\">Royalty Free N...",
  "reviewsCount": 2,
  "ratingScore": 2,
  "badges": [
    'BEST PRICE GUARANTEED',
    'NEW',
    'TOP SELLING',
    'QUALITY VERIFIED',
    '3D PRINT VERIFIED',
    'TOP RATED',
    'AI GENERATED',
    'DESIGNER\'S PICK',
  ],
  "mockedPricingData": {
    "price": 15.48,
    "originalPrice": 22.12,
    "discount": 0.29,
    "discountAmount": 6.63,
    "ribbon": "saleOff",
  },
}

// Shared by both extraction variants: mockedIsActiveSubscriber picks the subscriber status
// over the plan selector. Neither state reaches extraction, which never resolves pageConfig.
export const subscriptionPricingAreaMockedData = {
  ...pricingAreaMockedData,
  "subscriptionSubscribed": true,
  "planName": "CGTrader Essentials",
  "subscriptionPricePerModel": "$0.40",
  "subscriptionPerModelLabel": "per model",
  "subscriptionFromPriceLabel": "from",
  "subscriptionMonthlyPrice": "$9.99",
  "subscriptionPriceUnit": "/month",
  "subscriptionDownloadsPerMonth": 25,
  "subscriptionCatalogValue": "700K",
}

export const freePricingAreaMockedData = {
  "productId": 9,
  "title": "Lightweight Steel Wallet",
  "price": "$0.00",
  "free": true,
  "license": "royalty_free_no_ai",
  "customLicense": "<p><span class=\"translation_missing\" title=\"translation missing: en.licenses_new.summary.royalty_free_no_ai_html, link: &lt;form rel=&quot;nofollow&quot; class=&quot;license-form&quot; method=&quot;get&quot; action=&quot;/items/9/license&quot; data-remote=&quot;true&quot;&gt;&lt;input class=&quot;js-auto-disable-link js-license license button button--transparent&quot; rel=&quot;nofollow&quot; type=&quot;submit&quot; value=&quot;Royalty Free No Ai License&quot; /&gt;&lt;/form&gt;\">Royalty Free No...",
  "reviewsCount": 0,
  "ratingScore": 0,
  "badges": [],
  "mockedPricingData": {
    "price": 0,
    "originalPrice": 0,
    "discount": 0,
    "discountAmount": 0,
  },
}
